import { useEffect, useState } from "react";

import { useChainId } from "@/entities/chain-id/context/use-chain-id";
import { PoolName } from "@/shared/constants/pools";
import { LiquidationMap } from "@/shared/types/chart-risk";
import { ChainName } from "@/shared/types/networks";
import { request } from "@/shared/utils/request";

import { getPoolParams } from "../utils/get-pool-params";

export const useLiquidationData = (
  poolName: PoolName,
  chainName: ChainName,
) => {
  const [data, setData] = useState<LiquidationMap>();
  const chainId = useChainId();

  useEffect(() => {
    const poolParams = getPoolParams(poolName, chainName);
    if (!poolParams || !chainId) return;
    const fetchTradingData = async () => {
      const response = await request<LiquidationMap>(
        `chain/${chainId}/marginlyPool/${poolParams.address}/chart/liquidation`,
      );

      setData(response);
    };
    fetchTradingData();
  }, [chainId, chainName, poolName]);

  return data;
};
